<template>
  <div class="wrapper">
    <div class="checkboxDescription"><span>表示する広告主：</span></div>
    <div>
      <v-checkbox
        :key="index"
        v-for="(option, index) in selectOptions"
        :label="option.text"
        @change="onActiveFilterChange(option.value)"
        :input-value="searchAndFilter.activeFilter[option.value]"
        class="checkbox"
        hide-details
        messages="none"
      />
    </div>
    <v-spacer />
    <AdvertiserListSearchBox @onTextChange="onTextChange" />
    <PageSelect
      :value="advertiserList"
      @input="pagination"
      style="width:200px;"
      class="pl-4"
    />
  </div>
</template>

<script>
import PageSelect from '@/components/Shared/Search/PageSelect'
import AdvertiserListSearchBox from '@/components/LoginLp/Report/AdvertiserListSearchBox'
import debounce from 'lodash/debounce'

export default {
  name: 'SearchAndFilter',
  components: {
    PageSelect,
    AdvertiserListSearchBox,
  },
  props: {
    searchAndFilter: {
      type: Object,
      default: () => {},
    },
    onActiveFilterChange: {
      type: Function,
      default: () => {},
    },
    advertiserList: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    selectOptions() {
      return [
        { text: '有効', value: 'active' },
        { text: '無効', value: 'inactive' },
      ]
    },
  },
  methods: {
    pagination(pageNo) {
      this.$emit('pagination', pageNo)
    },
    onTextChange: debounce(function(keyword) {
      this.$emit('onTextChange', keyword)
    }, 1000),
  },
}
</script>

<style scoped>
.wrapper {
  display: flex;
  margin-bottom: 10px;
  justify-content: space-between;
}

.checkboxDescription {
  width: 130px;
  padding-top: 24px;
  font-size: 16px;
  color: #666;
}
.checkbox {
  padding-top: 8px;
  display: inline-block;
  margin-right: 15px;
}
</style>
